import { cn } from '~/lib/utils'

type FieldState = {
  error?: {
    message?: string
  }
  isTouched?: boolean
}

type FieldErrorMessageProps = {
  fieldState: FieldState
  requireTouched?: boolean
  className?: string
}

export const FieldErrorMessage = ({
  fieldState,
  requireTouched = false,
  className,
}: FieldErrorMessageProps) => {
  const shouldShowError = requireTouched
    ? fieldState.isTouched && fieldState.error?.message
    : !!fieldState.error?.message

  const errorMessage = fieldState.error?.message || '\u00A0'

  return (
    <p
      className={cn(
        'text-sm font-medium text-red-500 mt-2 min-h-[1.5rem]',
        !shouldShowError && 'invisible',
        className
      )}
      aria-live="polite"
      role={shouldShowError ? 'alert' : undefined}
    >
      {errorMessage}
    </p>
  )
}
